import moment from 'moment';
import React, { Component } from 'react'
import { CURRENCY, SYMBOL, development, INFO_FOLIO, Datos_Empresa } from "../../../libs/utils/Const";
import config from "../../../config";
import { GeneralFunctions } from "../../../components/index";
import { element } from 'prop-types';
const _generalFunctions = new GeneralFunctions();
class SalesPayments extends Component {

    mDocCum = (movement = {}) => {
        const { DocNum = '', ORCTDocNum = '', ObjType = '' } = movement
        let newDocNum = '';

        if (ObjType) {
            switch (Number(ObjType)) {
                case 13:
                    newDocNum = DocNum ?? '';
                    break;
                case 24:
                    newDocNum = ORCTDocNum ?? '';
                    break;
                default:
                    newDocNum = '';
                    break;
            }
        }
        return newDocNum;
    }

    mNumAtCard = (movement = {}) => {
        const { NumAtCard = '', ObjType = '', CertificateRef = '' } = movement
        let newDocNum = '';

        if (ObjType) {
            switch (Number(ObjType)) {
                case 13:
                    newDocNum = NumAtCard ?? '';
                    break;
                case 24:
                    newDocNum = CertificateRef ?? '';
                    break;
                default:
                    newDocNum = '';
                    break;
            }
        }
        return newDocNum;
    }

    render() {
        const { Movements, } = this.props;
        const USER = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />{/*<strong>{"InfoByFolio ? InfoByFolio.folio : ''"}</strong>*/}</p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>HISTORIAL DE OPERACIÓN</strong></h5>
                            </div>
                            <div className="col-3">
                                <span className="text-left">SUCURSAL: {USER.Sucursal ?? ''}</span>
                                <p>{USER.Branch.Address ?? ''}</p>
                            </div>
                        </div>
                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-6 text-left'>
                                <h6><strong>Operaciones: </strong></h6>
                            </div>
                            <div className='col-6 text-right'>

                            </div>
                            <div className='col-12'>
                                <table>
                                    <thead style={{ border: "solid 1px" }}>
                                        <tr>
                                            <th className="text-left"> Detalle </th>
                                            <th className="text-left">Linea indice</th>
                                            <th className="text-left">Monto</th>
                                            <th className="text-left">Nombre pago</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Movements && Movements.sessionMovements.length > 0 &&
                                            Movements.sessionMovements.map((movement) => {
                                                const infoFolio = INFO_FOLIO.InfoFolio(movement.folio);
                                                return (
                                                    <>
                                                        {((infoFolio.folioID === 'RT' || infoFolio.folioID === 'CN') && (!!movement.reBillP && movement.reBillP === 'Y')) ?
                                                            <></>
                                                            :
                                                            <tr style={{ fontSize: '12px', borderTop: "solid 1px" }}>
                                                                <td rowSpan={"refounds.body.length"} className="text-left" style={{ borderRight: "solid 0px" }}>
                                                                    <table style={{ borderRight: "solid 2px" }}>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td colSpan={1}>No. Documento</td>
                                                                                <td colSpan={3}>{movement.docNum ?? ''}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={1}>No.Ref.de. cliente</td>
                                                                                <td colSpan={3}>{movement.NumAtCard ?? ''}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={1}>Folio</td>
                                                                                <td colSpan={3}>{movement.folio ?? ''}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={1}>Folio consecutivo</td>
                                                                                <td colSpan={3}>{movement.nextFolio ?? ''}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={1}>Cliente</td>
                                                                                <td colSpan={3}>{movement.cardCode ?? ''}</td>
                                                                            </tr>

                                                                            <tr>
                                                                                <td colSpan={1}>Fecha:</td>
                                                                                <td colSpan={3}>{moment(movement.docDate).format('YYYY-MM-DD') ?? ''}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>No. TipoDoc:</td>
                                                                                <td>{movement.docObjectType ?? ''}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={1}>Importe Total:</td>
                                                                                <td colSpan={3}>{`${CURRENCY} ${movement.docTotal ?? ''}`}</td>
                                                                            </tr>
                                                                            {movement.isDeliveryInvoice === 'Y' &&
                                                                                <tr>
                                                                                    <td colSpan={1}>Factura a domicilio</td>

                                                                                </tr>
                                                                            }
                                                                            {(movement.isDraft === 'Y' || Number(movement.docObjectType ?? 0) === 112) &&
                                                                                <tr>
                                                                                    <td colSpan={1}>Borrador/Autorización</td>
                                                                                </tr>
                                                                            }
                                                                            {infoFolio.folioID === 'IV' && !!movement.reBillP && movement.reBillP === 'Y' &&
                                                                                <tr>
                                                                                    <td colSpan={1}>Refacturación </td>
                                                                                    <td colSpan={1}>NO AFECTA EL CORTE</td>
                                                                                </tr>
                                                                            }
                                                                            {movement.CANCELED && movement.CANCELED === 'Y' &&
                                                                                <tr>
                                                                                    <td colSpan={1}>DOCUMENTO CANCELADO</td>
                                                                                </tr>
                                                                            }

                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                                {movement && movement.payments && movement.payments.length > 0 &&
                                                                    movement.payments.map((payment, index) => {
                                                                        return (
                                                                            <>
                                                                                {(movement.isDeliveryInvoice === 'Y' && movement.paidOut === 'N') ?
                                                                                    <>

                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <td className="text-left align-top">{index + 1}</td>
                                                                                        <td className="text-left align-top">{`${CURRENCY} ${payment.amount ?? ''}`}</td>
                                                                                        <td className="text-left align-top">{`${payment.pm_Name ?? ''} `}</td>
                                                                                    </>
                                                                                }

                                                                            </>
                                                                        )
                                                                    })

                                                                }

                                                            </tr>
                                                        }

                                                    </>
                                                )
                                            })
                                        }


                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* DETALLE DEL PAGO */}
                        {Movements && Movements?.invoiceDetails && Movements?.invoiceDetails?.length > 0 &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Detalle del pago: </strong></h6>
                                </div>
                                <div className='col-6 text-right'></div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left">N° Pago</th>
                                                <th className="text-left">N° Documento</th>
                                                <th className="text-left">No.Ref.de. Cliente</th>
                                                <th className="text-left">Clase de Documento</th>
                                                <th className="text-left">Fecha</th>
                                                <th className="text-left">Total</th>
                                                <th className="text-left">Pago Total</th>
                                                <th className="text-left">Importe Percepción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Movements.invoiceDetails.map((detail, idx) => (
                                                <tr key={idx} style={{ fontSize: '12px', borderTop: 'solid 1px' }}>
                                                    <td className="text-left">{detail.docNum ?? ''}</td>
                                                    <td className="text-left">{detail.DocNum ?? ''}</td>
                                                    <td className="text-left">{detail.NumAtCard ?? ''}</td>
                                                    <td className="text-left">{Number(detail.ObjType) === 13 ? 'Factura de cliente' : Number(detail.ObjType) === 30 ? 'Asiento de percepción' : detail.ObjType ?? ''}</td>
                                                    <td className="text-left">{detail.TaxDate ? moment(detail.TaxDate).format('YYYY-MM-DD') : ''}</td>
                                                    <td className="text-left">{`${CURRENCY} ${Number(detail.DocTotal ?? 0).toFixed(2)}`}</td>
                                                    <td className="text-left">{`${CURRENCY} ${Number(detail.totalPago ?? 0).toFixed(4)}`}</td>
                                                    <td className="text-left">{`${CURRENCY} ${Number(detail.U_PRC_IMP ?? 0).toFixed(2)}`}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        {/* GASTOS ADMINISTRATIVOS */}
                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-6 text-left'>
                                <h6><strong>Gastos Administrativos: </strong></h6>
                            </div>
                            <div className='col-6 text-right'>

                            </div>
                            <div className='col-12'>
                                <table>
                                    <thead style={{ border: "solid 1px" }}>
                                        <tr>
                                            <th className="text-left">Factura Principal</th>
                                            <th className="text-left">Número de documento</th>
                                            <th className="text-left">No.Ref.de. cliente</th>
                                            <th className="text-left">Código de Cliente</th>
                                            <th className="text-left">Nombre de Cliente</th>
                                            <th className="text-left">Fecha</th>
                                            <th className="text-left">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Movements && Movements.gastosAdministrativos.length > 0 &&
                                            Movements.gastosAdministrativos.map((movement) => {

                                                return (
                                                    <tr style={{ fontSize: '12px', borderTop: "solid 1px" }}>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {movement.OriginalNumAtCard ?? ''}</td>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {movement.DocNum ?? ''}</td>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {movement.NumAtCard ?? ''}</td>
                                                        <td className="text-left"> {movement.CardCode ?? ''}</td>
                                                        <td className="text-left"> {movement.CardName ?? ''}</td>
                                                        <td className="text-left"> {moment(movement.DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                                        <td className="text-left"> {`${CURRENCY} ${Number(movement.DocTotal ?? 0).toFixed(2)}`}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* CESION EN USO */}
                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-6 text-left'>
                                <h6><strong>Cesión en uso: </strong></h6>
                            </div>
                            <div className='col-6 text-right'>

                            </div>
                            <div className='col-12'>
                                <table>
                                    <thead style={{ border: "solid 1px" }}>
                                        <tr>
                                            <th className="text-left">Factura Principal</th>
                                            <th className="text-left">Tipo</th>
                                            <th className="text-left">Número de documento</th>
                                            <th className="text-left">No.Ref.de. cliente</th>
                                            <th className="text-left">Código de Cliente</th>
                                            <th className="text-left">Nombre de Cliente</th>
                                            <th className="text-left">Fecha</th>
                                            <th className="text-left">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Movements && Movements.cesionEnUso.length > 0 &&
                                            Movements.cesionEnUso.map((movement) => {

                                                return (
                                                    <tr style={{ fontSize: '12px', borderTop: "solid 1px" }}>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {movement.OriginalNumAtCard ?? ''}</td>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {movement.ObjType ?? ''}</td>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {this.mDocCum(movement)}</td>
                                                        <td className="text-left" style={{ borderRight: "solid 0px" }}> {this.mNumAtCard(movement)}</td>
                                                        <td className="text-left"> {movement.CardCode ?? ''}</td>
                                                        <td className="text-left"> {movement.CardName ?? ''}</td>
                                                        <td className="text-left"> {moment(movement.DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                                        <td className="text-left"> {`${CURRENCY} ${Number(movement.DocTotal ?? 0).toFixed(2)}`}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </td></tr></table>
            </>
        )
    }
}

export default SalesPayments